import { Typography } from "@mui/material";
import type { JSX } from "react";

interface ControlGroupProps {
  label: React.ReactNode;
  children: JSX.Element;
  required?: boolean;
}

export function ControlGroup({ label, children, required }: ControlGroupProps) {
  return (
    <>
      <Typography>{label}</Typography>
      {required ? <Typography> *</Typography> : null}
      {children}
    </>
  );
}
